<template>
    <div class="message-center-floating">
        <div ref="bellRef" class="bell-container">
            <veui-icon name="bell" class="bell-icon"/>
            <span v-if="showCount" class="count-icon">{{ count|formatCount }}</span>
        </div>
        <veui-popover
            :open.sync="open"
            theme="ai"
            target="bellRef"
            position="bottom-end"
            overlay-class="message-center-floating-popover"
        >
            <div class="message-center-floating-popover-container">
                <message-tab
                    class="message-center-floating-popover-header"
                    :total-map="totalMap"
                    :active.sync="active"
                />
                <div class="ignore-btn">
                    <veui-button
                        theme="ai"
                        ui="text"
                        :disabled="totalMap[active] === 0"
                        @click="handleIgnore"
                    >忽略全部</veui-button>
                </div>
                <div
                    v-for="tab in messageTypeList"
                    :key="tab.name"
                    :type="tab.name"
                    class="message-center-floating-popover-body"
                    :style="{display: active === tab.name ? 'flex' : 'none'}"
                >
                    <div
                        v-if="totalMap[active] === 0"
                        class="message-center-floating-popover-body-empty"
                    >
                        <veui-empty desc="还没有消息"/>
                    </div>
                    <div v-else>
                        <message-item
                            v-for="item in list[tab.name]"
                            :key="item.messageId"
                            class="message-center-floating-popover-item"
                            :type="tab.name"
                            :data="item"
                            :max-line="2"
                            :show-expand-icon="false"
                            :show-read-status="false"
                            :is-show="active === tab.name"
                            @click="handleClickMessage"
                            @clickLink="handleClickLink"
                        />
                    </div>
                </div>
                <div class="message-center-floating-popover-footer">
                    <veui-button
                        theme="ai"
                        ui="text strong"
                        @click="handleRedirect"
                    >查看全部消息</veui-button>
                </div>
            </div>

        </veui-popover>
    </div>
</template>

<script>
import {Icon, Tooltip, Button, Empty} from 'veui';
import {mapState, mapActions, mapMutations} from 'vuex';
import MessageTab from './components/MessageTab';
import MessageItem from './components/MessageItem.vue';
import {messageTypeList, IGNORE, READ} from './config';
import 'veui-theme-dls-icons/bell';
let messageCenterOpenTime = 0;
let messageCenterCloseTime = 0;
export default {
    name: 'messageCenterFloating', // 消息中心浮窗
    inject: ['$toast', 'model', 'alsLog'],
    components: {
        'veui-icon': Icon,
        'veui-popover': Tooltip,
        'veui-button': Button,
        'veui-empty': Empty,
        'message-tab': MessageTab,
        'message-item': MessageItem
    },
    props: {
    },
    filters: {
        formatCount(num) {
            return num > 99 ? '99+' : `${num}`;
        }
    },
    data() {
        return {
            messageTypeList,
            active: 'system',
            open: false

        };
    },
    computed: {
        ...mapState('message', ['systemMessages', 'personalMessages']),
        list() {
            return {
                system: this.systemMessages,
                personal: this.personalMessages
            };
        },
        systemMessagesCount() {
            return this.systemMessages.length;
        },
        personalMessagesCount() {
            return this.personalMessages.length;
        },
        totalMap() {
            return {
                system: this.systemMessagesCount,
                personal: this.personalMessagesCount
            };
        },
        count() {
            return this.systemMessagesCount + this.personalMessagesCount;
        },
        showCount() {
            return this.count > 0;
        }
    },
    watch: {
        open(val) {
            if (val) {
                messageCenterOpenTime = new Date().getTime();
            }
            else {
                messageCenterCloseTime = new Date().getTime();
                const exposeTime = messageCenterCloseTime - messageCenterOpenTime;
                this.alsLog({
                    f1: 'messageCenterPopoverExpose',
                    f2: 'show',
                    f11: exposeTime

                });
            }
        },
        active(val) {
            this.alsLog({
                f1: 'messageCenterPopoverTab',
                f2: 'click',
                f6: val
            });
        }
    },
    methods: {
        ...mapMutations('message', {
            'setRefreshUserCenterMessage': 'SET_REFRESH_USER_CENTER_MESSAGE'
        }),
        ...mapActions('message', [
            'getMessages',
            'getCount'
        ]),
        handleRedirect() {
            this.alsLog({
                f1: 'messageCenterRedirect',
                f2: 'click'
            });
            this.$router.push({name: 'messageCenter'});
        },
        async changeMessagesStatus(params) {
            try {
                await this.model.message.changeMessagesStatus(params);

                // 若当前在消息中心页面，需要刷新消息中心列表
                if (this.$route.name === 'messageCenter') {
                    this.setRefreshUserCenterMessage(this.active);
                    this.getCount({model: this.model, type: this.active});
                }
                // 刷新消息浮窗当前tab列表
                this.getMessages({type: this.active, model: this.model});
            }
            catch (e) {
                this.$toast.error(e.message);
            }

        },
        handleClickMessage(data) {
            this.open = false;
            const type = data.messageType;
            this.alsLog({
                f1: 'messageCenterPopoverClick',
                f2: 'click',
                f11: data.messageId
            });
            this.$router.push({
                name: 'messageCenter',
                query: {
                    active: type === 1 ? 'system' : 'personal'
                }
            });
        },
        handleClickLink(data) {
            this.open = false;
            this.alsLog({
                f1: 'messageCenterPopoverLinkClick',
                f2: 'click',
                f11: data.messageId
            });

            const params = {
                messagesIds: [data.messageId],
                changeStatus: READ
            };
            this.changeMessagesStatus(params);
        },
        async handleIgnore() {
            const messagesIds = this.list[this.active].map(item => item.messageId);
            const params = {
                messagesIds,
                changeStatus: IGNORE
            };
            this.changeMessagesStatus(params);
            this.alsLog({
                f1: 'messageCenterMarkIgnore',
                f2: 'click'
            });
        }
    },
    created() {
        // 获取全部未读的系统消息和个人消息
        this.getMessages({type: 'system', model: this.model}); // 系统
        this.getMessages({type: 'personal', model: this.model}); // 个人
    }
};
</script>

<style scoped lang="less">
.message-center-floating {
    display: inline-block;
    width: 16px;
    height: 16px;
    .bell-container {
        position: relative;
        .bell-icon {
            cursor: pointer;
            &:hover {
                color: #545B66;
            }
        }
        .count-icon {
            display: flex;
            min-width: 14px;
            height: 14px;
            padding: 0px 3px;
            justify-content: center;
            align-items: center;
            flex-shrink: 0;
            border-radius: 8px;
            background: var(--Red-7, #F53F3F);
            color: var(----G0, #FFF);
            font-size: 10px;
            font-weight: 500;
            line-height: 15px; /* 150% */
            position: absolute;
            top: 0;
            left: 0;
            transform: translate(6px, -8px);
            cursor: pointer;
        }
    }
    &-popover {
        left: 16px !important;
        /deep/ .veui-ai-tooltip {
            width: 400px;
            max-width: 400px;
            padding: 0;
            // overflow: hidden;
            border-radius: 12px;
            font-size: 14px;
        }
        &-header {
            padding: 12px 24px 0 24px;
            margin-bottom: 8px;
            /deep/ .veui-ai-tabs-menu {
                height: 44px;
            }
        }
        /deep/ .message-tabs {
            margin-top: 0;
        }
        /deep/ .veui-ai-tooltip-arrow {
            right: 18px;
            &::after {
                width: 11.89px;
                height: 11.89px;
                top: -8.408px;
                box-shadow: none;
            }
        }
        &-container {
            position: relative;
        }
        .ignore-btn {
            position: absolute;
            right: 24px;
            top: 12px;
            line-height: 44px;

            /deep/ .veui-ai-disabled {
                color: rgba(83,98,128,.5) !important;
                cursor: not-allowed;
            }
        }
        &-body {
            padding: 0 24px;
            display: flex;
            flex-direction: column;
            height: 288px;
            overflow: auto;
            &::-webkit-scrollbar {
                width: 0; /* 隐藏滚动条 */
            }
            &-empty {
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
        &-item {
            padding-top: 16px;
            padding-bottom: 16px;
            flex-shrink: 0;
        }
        &-footer {
            height: 48px;
            padding: 12px 24px 16px 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #FFF;
            border-radius: 0 0 16px 16px;
        }
    }
}

</style>